import {
  Component,
  ViewEncapsulation,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { AlertsDataService } from "../alerts-data.service";
import {
  faBell as faBellSolid,
  faAngleRight,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/pro-light-svg-icons";
import { Dictionary } from "src/app/store/models/common_types";
import { AlertsService } from "../alerts.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { AppService } from "src/app/app.service";
import {
  VAIconRegistryService,
  bell,
  chevronLeft,
  chevronRight,
} from "@va/core-library/icons";

@Component({
  selector: "app-alerts-popover",
  templateUrl: "./alerts-popover.component.html",
  styleUrls: ["./alerts-popover.component.scss"],
  host: { class: "alerts-popup-component" },
  encapsulation: ViewEncapsulation.None,
})
export class AlertsPopoverComponent implements OnChanges {
  @Output() onSet: EventEmitter<any> = new EventEmitter();
  @Input() params: Dictionary<any>;
  @Input() showCancelButton: boolean;
  @Input() actionType: string;
  @Input() okBtnText = "Set";
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  loading = true;
  allEventTypes: Array<any>;
  faBell = faBell;
  faBellSolid = faBellSolid;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  brokerList: Array<any> = [];
  showBrokers = false;
  showNotif = false;
  selectedBrokers: Array<any> = [];
  disabledBrokers = true;
  disabledSetButton = true;
  // ticker = "";
  allEntitledBrokers = false;
  notificationOptions: Dictionary<boolean> = {
    systemAlert: true,
    instant: false,
    daily: false,
    weekly: false,
  };
  alertsDataToSend: Dictionary<any>;
  alertsDataToSendInitial: Dictionary<any>;
  triggerType = "";
  key = "";
  brokerDataWatchlist: Dictionary<any>;
  eventTypesSelected: Array<any> = [];
  showLineItemDeltaConfig: boolean;
  constructor(
    private dataService: AlertsDataService,
    private service: AlertsService,
    private message: NzMessageService,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([bell, chevronRight, chevronLeft]);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.params &&
      changes.params.currentValue !== changes.params.previousValue
    ) {
      this.triggerType = changes.params.currentValue.type;
      this.key = changes.params.currentValue.key.toString();

      if (this.triggerType === "watchlist") {
        this.dataService
          .getUserBrokerEntitlementMap(this.key, true)
          .subscribe((response) => {
            if (response) {
              this.brokerList = [];
              this.brokerList = response.watchlist_entitled_broker_map[
                this.key
              ].sources.map((source) => {
                return {
                  broker_name: source,
                };
              });
              this.getAllEvents();
            }
          });
      } else {
        this.dataService.getBrokerList(this.key, true).subscribe(
          (response) => {
            this.brokerList = [];
            response.broker_analyst_map.forEach((source) => {
              if (response.sources.indexOf(source.broker_name) !== -1) {
                const brokerIndex = this.brokerList.findIndex(
                  (x) => x.broker_name === source.broker_name,
                );
                if (brokerIndex <= -1) {
                  this.brokerList.push(source);
                }
              }
            });
            this.getAllEvents();
          },
          (error) => {
            throw error;
          },
        );
      }
    }
  }

  getAllEvents() {
    this.dataService.getAllEventTypes(this.triggerType, this.key).subscribe(
      (response) => {
        this.allEventTypes = response.eventTypes;
        this.getUserAlerts();
      },
      (error) => {
        throw error;
      },
    );
  }

  getUserAlerts() {
    this.dataService.getUserAlertDetails(this.triggerType, this.key).subscribe(
      (response) => {
        let lidAlert = {};
        const alertsDetails = response.alerts.length
          ? response.alerts[0]
          : { alert_event_types: [] };
        this.eventTypesSelected = alertsDetails.alert_event_types;

        if (alertsDetails.alert_event_types.length > 0) {
          this.alertsDataToSend = {
            alert_email_frequency: alertsDetails.frequency,
            alert_event_types: alertsDetails.alert_event_types.map((ev) => {
              return ev.eventTypeName;
            }),
            toast_notifications: alertsDetails.toast_notifications,
            alert_id: alertsDetails.id,
          };
        } else {
          this.alertsDataToSend = {
            alert_email_frequency: ["daily"],
            alert_event_types: [],
            toast_notifications: true,
          };
        }
        this.alertsDataToSend.alert_trigger_type = this.triggerType;
        this.alertsDataToSend.alert_trigger_id = this.key;
        this.alertsDataToSend.alert_event_type_items_map = {};
        if (
          this.triggerType !== "watchlist" &&
          this.allEventTypes.findIndex(
            (eventType) => eventType.name === "LineItemDelta",
          ) > -1
        ) {
          lidAlert = this.eventTypesSelected.find(
            (event) => event.eventTypeName === "LineItemDelta",
          );
          if (!lidAlert) {
            this.dataService
              .getLineItemDeltaAlert(this.key)
              .subscribe((lidAlert) => {
                if (
                  lidAlert &&
                  (lidAlert as any).line_item_delta &&
                  !(lidAlert as any).line_item_delta.is_error
                ) {
                  this.alertsDataToSend.line_item_delta = (
                    lidAlert as any
                  ).line_item_delta;
                }
                this.loading = false;
              });
          } else {
            if (
              lidAlert &&
              (lidAlert as any).eventTypeItems &&
              !(lidAlert as any).eventTypeItems.is_error
            ) {
              this.alertsDataToSend.line_item_delta =
                (lidAlert && (lidAlert as any).eventTypeItems) || {};
            }
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
        this.bindUserAlertsData(alertsDetails);
        this.service.bindNotificationOptions(
          alertsDetails.toast_notifications,
          alertsDetails.frequency,
          this.notificationOptions,
        );

        this.alertsDataToSendInitial = JSON.parse(
          JSON.stringify(this.alertsDataToSend),
        );
      },
      (error) => {
        this.loading = false;
        throw error;
      },
    );
  }

  bindUserAlertsData(alertsDetails) {
    const selectedEventTypes = alertsDetails.alert_event_types.map(
      function (data) {
        return data.display_name;
      },
    );

    this.allEventTypes.map((data) => {
      const eventIndex = selectedEventTypes.indexOf(data.display_name);
      if (eventIndex > -1) {
        if (data.display_name === "Line Item Delta") {
          data.checked =
            alertsDetails.alert_event_types[
              eventIndex
            ].eventTypeItems.subscribed;
        } else {
          data.checked = true;
        }
      } else {
        data.checked = false;
      }
      if (data.display_name === "New Model") {
        this.disabledBrokers = data.checked ? false : true;
        let selectedBrokerList = data.checked
          ? alertsDetails.alert_event_types[eventIndex].eventTypeItems
          : this.brokerList.map((x) => x.broker_name);
        if (data.checked) {
          selectedBrokerList = alertsDetails.alert_event_types[eventIndex]
            .all_entitled_objects
            ? this.brokerList.map((x) => x.broker_name)
            : alertsDetails.alert_event_types[eventIndex].eventTypeItems;
          this.alertsDataToSend.alert_event_type_items_map[data.name] = {
            list: selectedBrokerList,
            all_entitled_objects:
              JSON.stringify(
                this.brokerList.map((x) => x.broker_name).sort(),
              ) === JSON.stringify(selectedBrokerList.sort()),
          };
        } else {
          selectedBrokerList = this.brokerList.map((x) => x.broker_name);
          this.alertsDataToSend.alert_event_type_items_map[data.name] = {
            list: [],
            all_entitled_objects: false,
          };
        }

        this.selectBrokers(selectedBrokerList, data.checked);
      }
      if (data.subcategories) {
        let selectedVal = 0;
        data.subcategories.map((subVal) => {
          if (selectedEventTypes.indexOf(subVal.display_name) > -1) {
            subVal.checked = true;
            selectedVal++;
          } else {
            subVal.checked = false;
          }
          return subVal;
        });
        if (selectedVal > 0) {
          data.checked = true;
        }
      }
      data.showTitle = false;
      data.titleText = "";
      if (data.display_name === "Earnings Preview" && this.key !== "-1") {
        data.showTitle = true;
        data.titleText =
          "Receive a snapshot of consensus estimates before earnings";
      }
      if (this.triggerType === "watchlist" && this.key === "-1") {
        if (data.display_name === "Earnings Preview") {
          data.showTitle = true;
          data.titleText =
            "Preview how your estimates compare to consensus before earnings.";
        }
        if (data.display_name === "Model Processed") {
          data.showTitle = true;
          data.titleText =
            "Get notified when your latest estimates are included in consensus.";
        }
      }
      return data;
    });
  }

  checkForChanges() {
    // console.log(action)
    // TODO
    if (
      this.alertsDataToSend.alert_email_frequency.length > 0 &&
      this.allEventTypes.filter((a) => a.checked).length > 0
    ) {
      this.disabledSetButton = false;
    } else {
      this.disabledSetButton = true;
    }
  }

  selectBrokers(brokerList: Array<string>, newModelMenuSelected: boolean) {
    this.brokerList.map((broker) => {
      if (brokerList.indexOf(broker.broker_name) > -1) {
        broker.checked = true;
      } else {
        broker.checked = false;
      }
      return broker;
    });
    this.onBrokerChanges(newModelMenuSelected, "onLoad");
  }

  showBrokersChange(showBrokers: boolean) {
    this.showBrokers = showBrokers;
  }
  showNotifChange(showNotif: boolean) {
    this.showNotif = showNotif;
  }
  showLineItemDeltaChange(showLineItemDeltaConfig) {
    this.showLineItemDeltaConfig = showLineItemDeltaConfig;
  }
  onEPChanges() {
    this.service.onEPChanges(this.allEventTypes, this.alertsDataToSend);
    this.checkForChanges();
  }

  onClickEventType(params) {
    const data = this.service.onClickEventType(
      params,
      this.disabledBrokers,
      this.allEventTypes,
      this.alertsDataToSend,
      this.brokerList,
    );
    this.disabledBrokers = data.disabledBrokers;
    if (params.display_name === "New Model") {
      this.onBrokerChanges(params.checked);
    }
    if (params.display_name === "Line Item Delta") {
      this.onLidSubscriptionChange(params.checked);
    }
    this.checkForChanges();
  }

  onBrokerChanges(onBrokerChanges?: boolean, action?: string) {
    const params = this.service.onBrokerChanges(
      this.brokerList,
      onBrokerChanges,
      this.allEntitledBrokers,
    );
    this.selectedBrokers = params.selectedBrokers;
    this.disabledBrokers = params.disabledBrokers;
    this.allEntitledBrokers = params.allEntitledBrokers;
    if (action !== "onLoad") {
      // updating alertsDataToSend for brokers change
      const modelEventType = this.allEventTypes.filter(function (data) {
        return data.display_name === "New Model";
      })[0];
      this.alertsDataToSend.alert_event_type_items_map[modelEventType.name] = {
        list: this.selectedBrokers,
        all_entitled_objects:
          JSON.stringify(this.brokerList.map((x) => x.broker_name).sort()) ===
          JSON.stringify(this.selectedBrokers.sort()),
      };
      if (this.selectedBrokers.length > 0 && !this.disabledBrokers) {
        modelEventType.checked = true;
        if (
          this.alertsDataToSend.alert_event_types.indexOf(
            modelEventType.name,
          ) === -1
        ) {
          this.alertsDataToSend.alert_event_types.push(modelEventType.name);
        }
      } else {
        modelEventType.checked = false;
        if (
          this.alertsDataToSend.alert_event_types.indexOf(modelEventType.name) >
          -1
        ) {
          this.alertsDataToSend.alert_event_types.splice(
            this.alertsDataToSend.alert_event_types.indexOf(
              modelEventType.name,
            ),
            1,
          );
        }
      }
      this.checkForChanges();
    }
  }

  onNotificationChanges(param: Array<string>) {
    const frequency = param.filter((frequency) => {
      return frequency !== "systemAlert";
    });
    this.alertsDataToSend.alert_email_frequency = frequency;
    this.alertsDataToSend.toast_notifications =
      param.indexOf("systemAlert") > -1;
    this.checkForChanges();
  }

  onClickCancel() {
    this.onCancel.emit(false);
  }

  getActionParams() {
    const isCompanyTab = this.params.type === "company";
    const isEditAction = this.eventTypesSelected.length > 0;
    const actionType = isEditAction ? "EDIT" : "CREATE";
    if (!isCompanyTab) {
      return {
        actionType,
        feature: isEditAction
          ? "WATCHLIST_ALERT_EDIT"
          : "WATCHLIST_ALERT_CREATE",
        actionSource: isEditAction
          ? "EDIT WATCHLIST ALERT"
          : "CREATE WATCHLIST ALERT",
      };
    }
    return {
      actionType,
      feature: isEditAction ? "USER_ALERT_EDIT" : "USER_ALERT_CREATE",
      actionSource: isEditAction ? "EDIT USER ALERT" : "CREATE USER ALERT",
    };
  }
  onClickSet() {
    const { actionType, feature, actionSource } = this.getActionParams();
    const isCompanyTab = this.params.type === "company";
    const watchlistId = isCompanyTab ? "" : this.params.key;
    this.dataService.submitAlertsData(this.alertsDataToSend).subscribe(
      () => {
        this.appService.logUserAction(
          {},
          "",
          "",
          feature,
          {
            alert_id: this.alertsDataToSend.alert_id,
            action: actionType,
            watchlistId: watchlistId,
          },
          "",
          actionSource,
        );
        this.message.create("success", `Alert successfully set.`);
        this.onSet.emit(false);
      },
      (error) => {
        console.error(error);
        this.message.create("error", `Error Saving Alert`);
        this.onSet.emit(false);
      },
    );
  }

  onChangeAllEntitled() {
    this.brokerList.map((x) => {
      x.checked = this.allEntitledBrokers;
      return x;
    });
    this.allEventTypes.map((data) => {
      if (data.display_name === "New Model") {
        data.checked = this.allEntitledBrokers;
        if (
          !data.checked &&
          this.alertsDataToSend.alert_event_types.indexOf(data.name) > -1
        ) {
          this.alertsDataToSend.alert_event_types.splice(
            this.alertsDataToSend.alert_event_types.indexOf(data.name),
            1,
          );
        } else {
          this.alertsDataToSend.alert_event_types.push(data.name);
        }
      }
      return data;
    });
    this.onBrokerChanges(this.allEntitledBrokers);
    this.checkForChanges();
  }

  onLidAlertChange(lidAlert) {
    this.alertsDataToSend.line_item_delta = lidAlert;
    this.checkForChanges();
  }

  onLidSubscriptionChange(value) {
    this.alertsDataToSend.line_item_delta.subscribed = value;
  }
}
